import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import Container from "../hoc/Container";

function OfferPage() {
  const location = useLocation();
  const [content, setContent] = useState("");
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    const path = "/offer.txt";
    fetch(path)
      .then((res) => {
        if (!res.ok) {
          throw new Error("Document not found");
        }
        return res.text();
      })
      .then((text) => {
        setContent(text);
      })
      .catch(() => setLoadError(true));
  }, []);

  const normalize = (value) =>
    value
      .toLowerCase()
      .replace(/[«»"]/g, "")
      .replace(/\s+/g, " ")
      .trim();

  const getAnchorId = (block) => {
    const normalized = normalize(block);
    if (normalized.includes("правила пользования сайтом")) {
      return "rules";
    }
    if (normalized.includes("договор публичной оферты")) {
      return "offer";
    }
    if (
      normalized.includes(
        "политика конфиденциальности и обработки персональных данных"
      )
    ) {
      return "privacy";
    }
    return null;
  };

  const blocks = useMemo(() => {
    if (!content) {
      return [];
    }
    const lines = content.replace(/\r\n/g, "\n").split("\n");
    const result = [];
    let current = "";
    const pushCurrent = () => {
      if (current.trim().length > 0) {
        result.push(current.trim());
      }
      current = "";
    };
    const isParagraphStart = (line) => {
      const trimmed = line.trim();
      if (!trimmed) {
        return false;
      }
      if (/^\d+(\.\d+)*\./.test(trimmed)) {
        return true;
      }
      if (/^[a-zа-я]\)/i.test(trimmed)) {
        return true;
      }
      if (
        /^(правила пользования|договор публичной оферты|политика конфиденциальности)/i.test(
          trimmed
        )
      ) {
        return true;
      }
      return false;
    };
    lines.forEach((line) => {
      const trimmed = line.trim();
      if (!trimmed) {
        pushCurrent();
        return;
      }
      if (isParagraphStart(trimmed)) {
        pushCurrent();
        current = trimmed;
        return;
      }
      current = current ? `${current} ${trimmed}` : trimmed;
    });
    pushCurrent();
    return result;
  }, [content]);

  useEffect(() => {
    if (!location.hash || blocks.length === 0) {
      return;
    }
    const id = location.hash.replace("#", "");
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [location.hash, blocks]);

  return (
    <Container>
      <section className="main-content-block">
        <h1 className="main-title">
          Договор публичной оферты и правила пользования сайтом
        </h1>
        <div className="offer-nav">
          <a href="#offer" className="offer-nav-link">
            Договор публичной оферты
          </a>
          <a href="#rules" className="offer-nav-link">
            Правила пользования сайтом
          </a>
          <a href="#privacy" className="offer-nav-link">
            Политика конфиденциальности и обработки персональных данных
          </a>
        </div>
        {loadError ? (
          <p className="offer-help">
            Не удалось загрузить документ. Проверьте файл
            <span className="inline-block px-1">/public/offer.txt</span>.
          </p>
        ) : (
          <div className="offer-text">
            {blocks.map((block, index) => {
              const anchorId = getAnchorId(block);
              return (
                <p
                  key={`blk-${index}`}
                  id={anchorId || undefined}
                  className={`offer-paragraph ${anchorId ? "offer-anchor" : ""}`}
                >
                  {block}
                </p>
              );
            })}
          </div>
        )}
      </section>
    </Container>
  );
}

export default OfferPage;
